import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SubAccountsState } from './sub-accounts.state';

export const selectSubAccountsState =
  createFeatureSelector<SubAccountsState>('subAccounts');

export const selectAllSubAccounts = createSelector(
  selectSubAccountsState,
  (state: SubAccountsState) => state.subAccounts
);

export const selectSubAccountsLoading = createSelector(
  selectSubAccountsState,
  (state: SubAccountsState) => state.loading
);

export const selectSubAccountsError = createSelector(
  selectSubAccountsState,
  (state: SubAccountsState) => state.error
);

export const selectSubAccountsByType = (accountType: string) =>
  createSelector(selectAllSubAccounts, (subAccounts) =>
    subAccounts.filter((account) => account.accountType === accountType)
  );

export const selectSubAccountsCount = createSelector(
  selectAllSubAccounts,
  (subAccounts) => subAccounts.length
);

export const selectSubAccountById = (id: string) =>
  createSelector(selectAllSubAccounts, (subAccounts) =>
    subAccounts.find((account) => account._id === id)
  );
